export default "__VITE_ASSET__998326bb__"